import React, { useCallback, useEffect, useState } from "react";
import { Input, InputGroup } from "@chakra-ui/react";

import { useDebounce } from "@shared/hooks";
import { CloseIcon, SearchIcon } from "@shared/components/Icons";

export interface InputSearchProps extends React.HTMLProps<HTMLInputElement> {
  onChangeSearch: (value: string) => void;
  showClearText?: boolean;
  showClose?: boolean;
  onChangeShowSearch?: (value: boolean) => void;
}

const InputSearch = (props: InputSearchProps) => {
  const { onChangeSearch, value, showClose, onChangeShowSearch } = props;
  const [inputValue, setInputValue] = useState<string>(value ? String(value) : "");
  const [showSearch, setShowSearch] = useState(!showClose || !!value);
  const [prevValue, setPrevValue] = useState(value);
  const debounceValue = useDebounce<string>(inputValue, 500);

  if (value !== prevValue) {
    setPrevValue(value);
    setInputValue(value ? String(value) : "");
    if (value) {
      setShowSearch(true);
    }
  }

  useEffect(() => {
    onChangeShowSearch && onChangeShowSearch(showSearch);
  }, [onChangeShowSearch, showSearch]);

  useEffect(() => {
    if (debounceValue !== value && debounceValue !== undefined) {
      onChangeSearch(debounceValue);
    }
  }, [debounceValue, onChangeSearch, inputValue, value]);

  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const clearInput = useCallback(() => {
    setInputValue("");
  }, []);

  return (
    <InputGroup
      bg="brand.white"
      borderRadius="base"
      startElement={<SearchIcon color="#CBD5E0" />}
      startElementProps={{ px: 0, w: "40px", fontSize: "md" }}
      endElementProps={{ px: 0, w: "40px", fontSize: "md" }}
      endElement={
        inputValue ? <CloseIcon color="brand.secondary" cursor="pointer" w="12px" onClick={clearInput} /> : undefined
      }
    >
      <Input
        h="48px"
        value={inputValue}
        onChange={onChangeInput}
        placeholder="Search"
        _focusVisible={{ borderColor: "brand.inputFocusBorder" }}
      />
    </InputGroup>
  );
};

export default InputSearch;
